<div class="dialog-header"
cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
        {{headerLabel}}
    </div>
    <button type="button" mat-icon-button class="close-btn" (click)="onCancel()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content>
    <form [formGroup]="form" id="dailyDosingForm"  #dailyDosingForm="ngForm" class="form-grid">
        <div class="form-grid-row cols-2" >
            <ng-container *ngFor="let col of fields">
                <ng-container *ngIf="uiState[col.key]?.visible">
                    <input type="hidden" *ngIf="col.type==='hidden'" [formControlName]="col.key"
                        [attr.data-testid]="col.key" />
                    <mat-form-field  appearance="outline" *ngIf="col.type==='text'">
                        <mat-label>{{uiState[col.key]?.label}}</mat-label>
                        <input  matInput [formControlName]="col.key"   [attr.data-testid]="col.key" [maxlength]="col.key === 'Comments' ? 2000 : 50"/>
                    </mat-form-field>
                    <mat-form-field appearance="outline" *ngIf="col.type==='number'">
                        <mat-label>{{uiState[col.key]?.label}}</mat-label>
                        <input matInput [formControlName]="col.key" type="text" (input)="roundOff($event, 999999, 2, col.key)" [attr.data-testid]="col.key" (keydown)="numberOnly($event)"/>
                    </mat-form-field>
                    <app-datetime-picker-input *ngIf="col.type==='date'" [label]="uiState[col.key]?.label"
                        [formControlName]="col.key" [attr.data-testid]="col.key" panelPosition="right" [use24Hour]="false">
                    </app-datetime-picker-input>
                </ng-container>
            </ng-container>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button type="button" mat-raised-button color="primary" mat-primary (click)="onCancel()">
        Cancel
    </button>
    @if(canSave){
        <button type="submit" form="dailyDosingForm" mat-raised-button color="primary" mat-primary (click)="onSave()">
            Save
        </button>
    }
</mat-dialog-actions>